import { useEffect, useState } from "react";

export const useFilteredData = (data, filterPredicate, getItemKey) => {
  const [filterValue, setFilterValue] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);

  // Get filtered data
  const getFilteredData = () => {
    if (!data) return [];
    if (!filterValue) return data;
    return data.filter((item) => filterPredicate(item, filterValue));
  };

  const filteredData = getFilteredData();

  // Update selected items when filter changes
  useEffect(() => {
    setSelectedItems((prev) =>
      prev.filter((selected) =>
        filteredData.some((item) => getItemKey(item) === getItemKey(selected))
      )
    );
  }, [data, filterValue]);

  // Selection handlers
  const handleItemSelection = (item, isSelected) => {
    if (isSelected) {
      setSelectedItems((prev) => [...prev, item]);
    } else {
      setSelectedItems((prev) =>
        prev.filter((selected) => getItemKey(selected) !== getItemKey(item))
      );
    }
  };

  const handleSelectAll = (isSelected) => {
    setSelectedItems(isSelected ? [...filteredData] : []);
  };

  const isItemSelected = (item) => {
    return selectedItems.some(
      (selected) => getItemKey(selected) === getItemKey(item)
    );
  };

  const clearSelection = () => {
    setSelectedItems([]);
  };

  return {
    filterValue,
    setFilterValue,
    filteredData,
    selectedItems,
    handleItemSelection,
    handleSelectAll,
    isItemSelected,
    clearSelection,
    isAllSelected:
      selectedItems.length === filteredData.length && filteredData.length > 0,
    hasSelection: selectedItems.length > 0,
  };
};
